import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAJC-MqiQjBwR3YzUkdsO6AlTV0Mzxy9_c",
  authDomain: "hi-nano-3a847.firebaseapp.com",
  databaseURL: "https://hi-nano-3a847-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hi-nano-3a847",
  storageBucket: "hi-nano-3a847.appspot.com",
  messagingSenderId: "50224844526",
  appId: "1:50224844526:web:6a79047d09699d8846edff",
  measurementId: "G-YPNGJMDGC3"
};

const app = initializeApp(firebaseConfig);

const login = async (email, password) => {
    if (email !== 'admin') {
        return {success: false, message: 'Username salah.'};
    } else {
        const auth = getAuth(app);
        return signInWithEmailAndPassword(auth, email+'@hinano.com', password)
            .then(async (userCredential) => {
                const user = userCredential.user;
                const token = await user.getIdToken();
                return {success: true, data: token};
            })
            .catch((error) => {
                return {success: false, message: error.message};
            });
    }
};

export { login }